import { get, isEmpty } from 'lodash'

export default {
  props: {
    formName: {
      type: String,
    },
  },
  data() {
    return {
      timeoutId: null,
    }
  },
  computed: {
    fieldByPath() {
      return this.$get('expressionFieldByPath')
    },
    field: {
      get() {
        return (this.fieldByPath && this.fieldByPath(this.path)) || {}
      },
    },
    value: {
      get() {
        return this.field.hasOwnProperty('subForm') ? get(this.field, 'subForm.rows') : get(this.field, 'value')
      },
      set(value) {
        this.$dispatch('updatePropByPath', {
          path: this.path,
          prop: 'value',
          value,
          formName: this.formName,
        })
      },
    },
    hidden: {
      get() {
        return get(this.field, 'hidden')
      },
      set(value) {
        this.$dispatch('updatePropByPath', {
          path: this.path,
          prop: 'hidden',
          value,
          formName: this.formName,
        })
      },
    },
    readOnly: {
      get() {
        return Boolean(get(this.field, 'readOnly'))
      },
      set(value) {
        this.$dispatch('updatePropByPath', {
          path: this.path,
          prop: 'readOnly',
          value,
          formName: this.formName,
        })
      },
    },
    list: {
      get() {
        return get(this.field, 'list') || []
      },
      set(value) {
        this.$dispatch('updatePropByPath', {
          path: this.path,
          prop: 'list',
          value,
          formName: this.formName,
        })
      },
    },
    name: {
      get() {
        return get(this.field, 'name')
      },
    },
    id: {
      get() {
        return get(this.field, 'id')
      },
    },
    type: {
      get() {
        return get(this.field, 'type')
      },
    },
    label: {
      get() {
        return get(this.field, 'label')
      },
      set(value) {
        this.$dispatch('updatePropByPath', {
          path: this.path,
          prop: 'label',
          value,
          formName: this.formName,
        })
      },
    },
    formattedValue: {
      get() {
        const value = get(this.field, 'value')
        return get(this.field, 'formattedValue') || isEmpty(value) ? '' : value
      },
      set(value) {
        this.$dispatch('updatePropByPath', {
          path: this.path,
          prop: 'formattedValue',
          value,
          formName: this.formName,
        })
      },
    },
    required: {
      get() {
        const required = get(this.field, 'validations.required')
        return required || false
      },
      set(value) {
        this.$commit('FORM_UPDATE_FIELD_REQUIRED', { path: this.path, value })
      },
    },
    validations: {
      get() {
        return get(this.field, 'validations')
      },
      set(value) {
        this.$dispatch('updatePropByPath', {
          path: this.path,
          prop: 'validations',
          value,
          formName: this.formName,
        })
      },
    },
    directInputEntry: {
      get() {
        return get(this.field, 'directInputEntry')
      },
    },
    needDebounce: {
      get() {
        return get(this.field, 'needDebounce', false)
      },
    },
    placeholder() {
      return this.field?.placeholder
    },
  },
}
